// import React, { useEffect, useState } from "react";
// import { Layout, Card } from "antd";
// import { motion } from "motion/react";
// import { API_BASE_URL } from "../../Config";
// import Title from "antd/es/skeleton/Title";

// const { Content } = Layout;

// const Alternateasana = () => {
//   const [allPages, setAllPages] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.3,
//         duration: 0.8,
//       },
//     },
//   };

//   const cardVariants = {
//     hidden: { opacity: 0, y: 40 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: { type: "spring", stiffness: 60, damping: 12 },
//     },
//   };

//   const cardStyle = {
//     padding: "20px",
//     borderRadius: "12px",
//     margin: "0 auto 40px auto",
//     width: "100%",
//     maxWidth: "900px",
//     boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
//     background: "#ffffff",
//   };

//   useEffect(() => {
//     const fetchAlternateAsanas = async () => {
//       try {
//         const res = await fetch(
//           `${API_BASE_URL}/allpages?page=alternate-asanas`,
//         );
//         const json = await res.json();
//         setAllPages(json?.data || []);
//       } catch (error) {
//         console.error("API Fetch Error", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAlternateAsanas();
//   }, []);

//   if (loading)
//     return <h2 style={{ textAlign: "center", marginTop: 40 }}>Loading…</h2>;

//   if (allPages.length === 0)
//     return (
//       <h2 style={{ textAlign: "center", marginTop: 40 }}>
//         No Alternate Asanas found.
//       </h2>
//     );

//   return (
//     <motion.div
//     className="alternativeAsana"
//       style={{
//         padding: "50px 20px",
//         background: "linear-gradient(to bottom right, #f0f9ff, #fff)",
//         minHeight: "100vh",
//       }}
//       initial="hidden"
//       animate="visible"
//       variants={containerVariants}
//     >
//       <motion.div
//         style={{
//           textAlign: "center",
//           marginBottom: "40px",
//           color: "#001529",
//           padding: "0 10px",
//         }}
//         initial={{ opacity: 0, y: -30 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.8, ease: "easeOut" }}
//       >
//         <motion.h1
//           className="responsive_heading_1"
//           style={{ fontSize: "35px" }}
//         >
//           Alternate Yoga Poses
//         </motion.h1>
//         <Title
//           level={1}
//           style={{
//             textAlign: "center",
//             color: "#001529",
//             marginBottom: 20,
//             marginTop: 50,
//           }}
//         >
//           Alternate Yoga Poses
//         </Title>
//       </motion.div>
//       <motion.div
//         style={{
//           background: "rgba(255,255,255,0.9)",
//           padding: "20px",
//           borderRadius: 12,
//           width: "100%",
//           maxWidth: "900px",
//           margin: "0 auto 40px auto",
//           boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
//         }}
//         variants={cardVariants}
//         initial="hidden"
//         whileInView="visible"
//         viewport={{ once: true }}
//       >
//         <h2
//           className="responsive_heading_2"
//           style={{ color: "#00796b", fontWeight: "600" }}
//         >
//           Asana and Alternative Asana
//         </h2>
//         <ol
//           className="responsive_content"
//           style={{ lineHeight: "1.7", fontSize: "16px" }}
//         >
//           <li>
//             Every yoga asana has an alternative asana that helps in achieving
//             the full benefits of the practice.
//           </li>
//           <li>
//             Practicing alternative asanas ensures overall body balance and
//             flexibility.
//           </li>
//           <ol>
//             <li>Side bend (right or left)</li>
//             <li>Twist (right or left)</li>
//             <li>Forward bend and back bend</li>
//             <li>Standing and inverted</li>
//           </ol>
//         </ol>
//       </motion.div>
//       {allPages.map((section) => (
//         <motion.div
//           key={section._id}
//           variants={cardVariants}
//           whileHover={{ scale: 1.02 }}
//         >
//           <Card
//             className="inner_card"
//             bordered={false}
//             style={{
//               ...cardStyle,
//               background: "#e1f1e3",
//             }}
//           >
//             <div
//               className="page-content"
//               dangerouslySetInnerHTML={{ __html: section.content }}
//             />
//           </Card>
//         </motion.div>
//       ))}
//     </motion.div>
//   );
// };

// export default Alternateasana;

import React, { useEffect, useState } from "react";
import { Layout, Card } from "antd";
import { motion } from "motion/react";
import { API_BASE_URL } from "../../Config";
import AdvertisementCard from "../AdvertisementCard";

const { Content } = Layout;

const Alternateasana = () => {
  const [allPages, setAllPages] = useState([]);
  const [loading, setLoading] = useState(true);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        duration: 0.8,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 60, damping: 12 },
    },
  };

  const cardStyle = {
    padding: "20px",
    borderRadius: "12px",
    margin: "0 auto 40px auto",
    width: "100%",
    maxWidth: "900px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
    background: "#ffffff",
  };

  useEffect(() => {
    const fetchAlternateAsanas = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/allpages?page=alternate-asanas`);
        const json = await res.json();
        setAllPages(json?.data || []);
      } catch (error) {
        console.error("API Fetch Error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAlternateAsanas();
  }, []);

  if (loading)
    return <h2 style={{ textAlign: "center", marginTop: 40 }}>Loading…</h2>;

  if (allPages.length === 0)
    return (
      <h2 style={{ textAlign: "center", marginTop: 40 }}>
        No Alternate Asanas found.
      </h2>
    );

  return (
    // ✅ Wrap in flex container like Breathe — content left, ad right
    <div style={{ display: "flex", justifyContent: "center", padding: "30px 10px" }}>
      <motion.div
        className="alternativeAsana"
        style={{
          padding: "50px 20px",
          background: "linear-gradient(to bottom right, #f0f9ff, #fff)",
          minHeight: "100vh",
          flex: 1,
        }}
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        {allPages.map((section) => (
          <motion.div
            key={section._id}
            variants={cardVariants}
            whileHover={{ scale: 1.02 }}
          >
            <Card
              className="inner_card"
              bordered={false}
              style={{
                ...cardStyle,
                background: "#e1f1e3",
              }}
            >
              <div
                className="page-content"
                dangerouslySetInnerHTML={{ __html: section.content }}
              />
            </Card>
          </motion.div>
        ))}
      </motion.div>

      {/* ✅ Ad card top right — same as Breathe component */}
      <AdvertisementCard />
    </div>
  );
};

export default Alternateasana;